import { createUseThemedStyles } from '@/hooks';

export const useGlobalStyles = createUseThemedStyles((theme) => ({
	'@global': {
		'#root': {
			overflow: 'hidden',
		},

		/* ----------------------------------------------------------- */
		/* Search input controls */
		/* ----------------------------------------------------------- */
		'input[type=search]::-ms-clear': {
			display: 'none',
			width: 0,
			height: 0,
		},
		'input[type=search]::-ms-reveal': {
			display: 'none',
			width: 0,
			height: 0,
		},
		'input[type="search"]::-webkit-search-decoration, input[type="search"]::-webkit-search-cancel-button, input[type="search"]::-webkit-search-results-button, input[type="search"]::-webkit-search-results-decoration': {
			display: 'none',
		},

		/* ----------------------------------------------------------- */
		/* Jasper reports */
		/* ----------------------------------------------------------- */
		'.visualizejs': {
			lineHeight: 'normal',
		},

		'._jrHyperLink': {
			cursor: 'pointer',
		},

		/* ----------------------------------------------------------- */
		/* Placeholder text */
		/* ----------------------------------------------------------- */
		'::-webkit-input-placeholder': {
			fontStyle: 'italic',
			color: theme.colors.gray600,
		},
		'::-moz-placeholder': {
			fontStyle: 'italic',
			color: theme.colors.gray600,
		},
		':-ms-input-placeholder': {
			fontStyle: 'italic',
			color: theme.colors.gray600,
		},
		':-moz-placeholder': {
			fontStyle: 'italic',
			color: theme.colors.gray600,
		},

		/* ----------------------------------------------------------- */
		/* Generics */
		/* ----------------------------------------------------------- */
		html: {
			height: '100%',
			fontSize: '10px',
		},
		body: {
			...theme.fonts.s,
			minHeight: '100%',
			position: 'relative',
			color: theme.colors.black,
			...theme.fonts.openSansRegular,
			backgroundColor: theme.colors.gray100,
		},
		hr: {
			margin: 0,
			opacity: 1,
			backgroundColor: theme.colors.gray300,
		},
		'.flex-1': {
			flex: 1,
		},

		'.html-editor': {
			'& ol': {
				marginBottom: 0,
				marginLeft: '2em',
				paddingLeft: '2em',
			},
			'& ul': {
				marginBottom: 0,
				marginLeft: '2em',
				paddingLeft: '2em',
			},
			'& .ql-indent-1:not(.ql-direction-rtl)': {
				marginLeft: '4em',
			},
			'& .ql-indent-2:not(.ql-direction-rtl)': {
				marginLeft: '8em',
			},
			'& .ql-indent-3:not(.ql-direction-rtl)': {
				marginLeft: '12em',
			},
			'& .ql-indent-4:not(.ql-direction-rtl)': {
				marginLeft: '16em',
			},
			'& .ql-indent-5:not(.ql-direction-rtl)': {
				marginLeft: '20em',
			},
			'& p': {
				margin: 0,
			},
			'& img': {
				maxWidth: '100%',
				display: 'block',
				margin: '0 auto',
				height: 'auto',
			},
			'& table': {
				'& tbody, & td, & tfoot, & th, & thead, & tr': {
					borderWidth: 1,
					padding: 8,
				},
			},
		},
	},
}));
